import api from "./api";
import { errorHandling } from "./error.handling";

// const basePath = `${process.env.REACT_APP_API_VEHICLE_BASE_URL}/v1/automaker`;
const basePath = "https://nc8.olharfixo.com.br/Vehicles/api/v3";
const manufacturerBasePath = `${process.env.REACT_APP_API_EQUIPMENT_BASE_URL}/manufacturers`;


async function create(payload) {
  return createManufacturer({
    ManufacturerName: payload?.ManufacturerName ?? payload?.manufacturerName ?? payload?.description ?? "",
  });
}

async function update(payload) {
  return updateManufacturer({
    ManufacturerId: payload?.ManufacturerId ?? payload?.manufacturerId ?? payload?.id ?? payload?.automakerId,
    ManufacturerName: payload?.ManufacturerName ?? payload?.manufacturerName ?? payload?.description ?? "",
  });
}

async function list() {
  
  try {
    let response = await api.get(`${basePath}/automakers`);
    let treated = errorHandling.handleResponse(
      response,
      "manufacturerService.list"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "manufacturerService.list");
    return null;
  }
}

async function getById(id) {
  try {
    let response = await api.get(`${manufacturerBasePath}/${id}`);
    let treated = errorHandling.handleResponse(
      response,
      "manufacturerService.getById"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "manufacturerService.getById");
    return null;
  }
}

async function createManufacturer(payload = {}) {
  try {
    const requestPayload = {
      ManufacturerName:
        payload?.ManufacturerName ?? payload?.manufacturerName ?? "",
    };

    let response = await api.post(
      `${manufacturerBasePath}`,
      JSON.stringify(requestPayload)
    );
    let treated = errorHandling.handleResponse(
      response,
      "manufacturerService.createManufacturer"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "manufacturerService.createManufacturer");
    return null;
  }
}

async function updateManufacturer(payload = {}) {
  try {
    const manufacturerId =
      payload?.ManufacturerId ?? payload?.manufacturerId ?? payload?.id;

    const requestPayload = {
      ManufacturerId: manufacturerId,
      ManufacturerName:
        payload?.ManufacturerName ?? payload?.manufacturerName ?? "",
    };

    let response = await api.put(
      `${manufacturerBasePath}/${manufacturerId}`,
      JSON.stringify(requestPayload)
    );
    let treated = errorHandling.handleResponse(
      response,
      "manufacturerService.updateManufacturer"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "manufacturerService.updateManufacturer");
    return null;
  }
}

export const manufacturerService = {
  create,
  update,
  list,
  getById,
  createManufacturer,
  updateManufacturer,
};
